<body class="login-bg">

  <main>
    <div class="bg-blur"></div>
    <div class="content-container">
      <ng-container *ngTemplateOutlet="customerView"></ng-container>
    </div>
  </main>

  <ng-template #customerView>
    <div #welcomeWords *ngIf="page == 1">
      <div class="header">
        <h1 style="font-weight: 900">Ihre Ladepark ist beinahe bereit</h1>
      </div>
      <div class="body">
        <p style="font-size: 1.125rem;">Es fehlen noch ein Passwort und Ihre Zustimmung für die Nutzung von
          CUBOS.Connect.</p>
      </div>
      <div class="footer">
        <div class="page-info">
          <span>{{page}}/3</span>
        </div>
        <div class="buttons">
          <button class="btn btn-accentCubos" (click)="nextPage()">Los geht's</button>
        </div>
      </div>
    </div>

    <!-- <div #requierements *ngIf="page == 2">
      <div class="header">
        <h3>Ihr bestelltes Abonnement:</h3>
        <container-element [ngSwitch]="userProfile?.subscriptionTypeId">
          <span class="badge bg-enterprise" *ngSwitchCase="4">Enterprise</span>
          <span class="badge bg-premium" *ngSwitchCase="3">Premium</span>
          <span class="badge bg-primary" *ngSwitchCase="2">Standard</span>
          <span class="badge bg-primary" *ngSwitchCase="1">Basic</span>
        </container-element>
      </div>
      <div class="body">
        <div class="subscription-details-container">
          <div class="subscription-details" *ngIf="!loadingSubscriptionDetails">
            <div class="sub-head">
              <h5 i18n="@@SubscribtionDetailsHeader">Abonnement-Details</h5>
            </div>
            <div class="sub-body">
              <div class="sub-list-item">
                <span i18n="@@Chargingstations">Ladestationen:</span>
                <span>{{ subscriptionDetails.chargingstationsCreate }}</span>
              </div>
              <div class="sub-list-item">
                <span i18n="@@ChargingGroups">Ladegruppen:</span>
                <span>{{ subscriptionDetails.chargingstationGroupsCreate }}</span>
              </div>
              <div class="sub-list-item">
                <span i18n="@@Users">Benutzer:</span>
                <span>{{ subscriptionDetails.manageUsersCreateCount }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="support">
          <app-svg source="icons/feather/help-circle" height="24"></app-svg>
          <span>
            Bei Fragen oder Problemen zu Ihrem Abonnement wenden Sie sich bitte an unseren
            <a href="https://www.cubos.com/kontakt" class="link-yellow">Kundensupport</a>,
            damit wir gemeinsam die für Sie optimale Lösung finden.
          </span>
        </div>
      </div>
      <div class="footer">
        <div class="page-info">
          <span>{{page}}/3</span>
        </div>
        <div class="buttons">
          <button *ngIf="page > 1" class="btn btn-darkShade" (click)="previousPage()">Zurück</button>
          <button class="btn btn-accentCubos" (click)="nextPage()">Bestätigen</button>
        </div>
      </div>
    </div> -->

    <div #requierements *ngIf="page == 2">
      <div class="header">
        <h3 style="font-weight: 900">Wählen Sie Ihr neues Passwort</h3>
      </div>
      <div class="body">
        <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)" class="d-flex flex-column"
          style="gap: 1.2rem">
          <div>
            <label id="newpw" for="newPassword" i18n="@@NewPasswordLabel">Neues Passwort</label>
            <input type="password" id="newPassword" formControlName="newPassword" class="form-control"
              (change)="checkPassword($event.target.value)" (keyup)="checkPassword($event.target.value)"
              [ngClass]="{ 'is-invalid': formService.validateControl('newPassword') }" placeholder="Neues Passwort"
              i18n-placeholder="@@NewPassword" />
            <div class="error">
              <em *ngIf="formService.validateControl('newPassword') && formService.hasError('newPassword', 'required')"
                i18n="@@NewPasswordRequiredError">Neues Passwort wird benötigt</em>
            </div>
            <div class="password-requirements">
              <span [class]="passwordHasUpperCase ? 'check' : ''" i18n="@@CapitalLetterHint">Großbuchstabe</span>
              <span [class]="passwordHasLowerCase ? 'check' : ''" i18n="@@LowercaseLetterHint">Kleinbuchstabe</span>
              <span [class]="passwordHasDigit ? 'check' : ''" i18n="@@DigitHint">Ziffer</span>
              <span [class]="passwordHasLength ? 'check' : ''" i18n="@@10CharactersLongHint">10 Zeichen lang</span>
              <span *ngIf="passwordHasSpecialCharacter" [class]="passwordHasSpecialCharacter ? 'check' : ''"
                i18n="@@SpecialCharacterHint">Sonderzeichen</span>
            </div>
          </div>

          <div>
            <label id="newpwc" for="newPasswordConfirm" i18n="@@ConfirmNewPasswordLabel">Neues Passwort
              wiederholen</label>
            <input id="newPasswordConfirm" formControlName="newPasswordConfirm" name="newPasswordConfirm"
              type="password" class="form-control" placeholder="Neues Passwort wiederholen"
              i18n-placeholder="@@RepeatNewPassword">
            <div class="error">
              <em
                *ngIf="formService.validateControl('newPasswordConfirm') && formService.hasError('newPasswordConfirm', 'required')"
                i18n="@@ConfirmNewPasswordRequiredError">Neues Passwort muss wiederholt werden</em>
              <em *ngIf="formService.hasError('newPasswordConfirm', 'mustMatch')"
                i18n="@@PasswordsNotIdenticError">Passwörter müssen übereinstimmen</em>
            </div>
          </div>

          <div>

            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="agbConfirm" formControlName="agbConfirm" />
              <label class="form-check-label" for="agbConfirm" i18n="@@agbConfirmDescription">
                Ich habe die
                <a href="https://uploads-ssl.webflow.com/63d9fc1e4a5c00a5ee5b1f3f/63e24d8ae16849e8e26e42a5_cubos_agb.pdf"
                  target="_blank" class="link-yellow" style="cursor: pointer;">AGB</a>
                der CUBOS Service GmbH gelesen und stimme diesen zu.*
              </label>
            </div>

            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="wrbConfirm" formControlName="wrbConfirm" />
              <label class="form-check-label" for="wrbConfirm" i18n="@@agbConfirmDescription">
                Mir sind die Widerrufsbelehrung gemäß den CUBOS Service GmbH
                <a href="https://uploads-ssl.webflow.com/63d9fc1e4a5c00a5ee5b1f3f/63e24d8ae16849e8e26e42a5_cubos_agb.pdf"
                  target="_blank" class="link-yellow" style="cursor: pointer;">AGB</a>
                bekannt.*
              </label>
            </div>

            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="dsbConfirm" formControlName="dsbConfirm" />
              <label class="form-check-label" for="dsbConfirm" i18n="@@agbConfirmDescription">
                Ich habe die
                <a data-bs-toggle="modal" data-bs-target="dsModal" class="link-yellow" style="cursor:pointer;"
                  (click)="openDSDialog()">Datenschutzbestimmungen</a>
                der CUBOS Service GmbH gelesen und stimme diesen zu.*
              </label>
            </div>

            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="infoConfirm" formControlName="infoConfirm" />
              <label class="form-check-label" for="infoConfirm" i18n="@@agbConfirmDescription">
                Ich bin damit einverstanden, neue Informationen über Produkte der CUBOS Service GmbH per E-Mail zu
                erhalten.
              </label>
            </div>

          </div>

        </form>
      </div>
      <div class="footer">
        <div class="page-info">
          <span>{{page}}/3</span>
        </div>
        <div class="buttons">
          <button *ngIf="page > 1" class="btn btn-darkShade" (click)="previousPage()">Zurück</button>
          <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)">
            <button type="submit" class="btn btn-accentCubos" [disabled]="!formService.form.valid">Weiter</button>
          </form>
        </div>
      </div>
    </div>

    <div #requierements *ngIf="page == 3">
      <div class="header">
        <h3 style="font-weight: 900">Perfekt, das Lademanagement kann beginnen</h3>
      </div>
      <div class="body" style="max-width: 45rem">
        <p style="font-size: 1.125rem;">Nach der Anmeldung erstellen Sie die Tarife für das Laden in Ihrem Ladepark.</p>
        
        <ul>
          <li>
            <h5>
              <app-svg source="icons/feather/coins" height="18" i18n="@@InvoicePricingHeader"></app-svg>
              <strong style="padding-left: 0.5rem; font-size: 1rem;">Manuelle Abrechnung</strong>
            </h5>
            <p>Wählen Sie Ladevorgänge eines Benutzers aus und erstellen Sie eine Rechnung</p>
          </li>
          <li>
            <h5>
              <app-svg source="icons/feather/credit-card" height="18"></app-svg>
              <strong style="padding-left: 0.5rem; font-size: 1rem;">Automatisierte Abrechnung</strong>
            </h5>
            <p>Ihre Benutzer zahlen monatlich automatisch alle eigenen Ladevorgänge</p>
          </li>
          <li>
            <h5>
              <app-svg source="icons/feather/qr-code" height="18"></app-svg>
              <strong style="padding-left: 0.5rem; font-size: 1rem;">QR-Code-Laden</strong>
            </h5>
            <p>Ermöglichen Sie Gästen das Laden und Bezahlen ganz ohne Registrierung</p>
          </li>
        </ul>
      </div>
      <div class="footer">
        <div class="page-info">
          <span>{{page}}/3</span>
        </div>
        <div class="buttons">
          <button class="btn btn-accentCubos" (click)="sendToLogin()">Jetzt anmelden</button>
        </div>
      </div>
    </div>
  </ng-template>

</body>